import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const SLR5_4FEET_LAYER_ID = 'slr5_4FeetLayer';

const layerConfig = {
  title: 'SLR 5.4 Feet',
};

function SLR5_4FeetLayer() {
  const dispatch = useDispatch();
  const { slr5_4FeetLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, slr5_4FeetLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  if (slr5_4FeetLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SLR5_4FEET_LAYER_ID,

      stroked: false,
      filled: true,
      getFillColor: [28, 88, 156],
      lineWidthMinPixels: 1,
      pickable: true,
      visible: slr5_4FeetLayer.visible,
      opacity: slr5_4FeetLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SLR5_4FEET_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['SLR_Zone_Area_Square_Meters'],
            }),
          };
        }
      },
    });
  }
}

export default SLR5_4FeetLayer;
